import { createApp } from "vue"
import "@wikimedia/codex/dist/codex.style.css"
import App from "./App.vue"
import { i18n } from "./i18n"
import "./style.css"

const app = createApp(App)
app.use(i18n)
app.mount("#app")
